import {gql} from "apollo-angular";
import {baseResponse} from "../../../base.graphql";

export const formFixedResponseFields = `
 id
        uniqueId
        name
        value
        dataType`

export const CREATE_FORM_FIXED_RESPONSE = gql`
  mutation CreateFormFixedResponsesMutation($input: FormFixedResponseFieldsInputObjects!) {
    createFormFixedResponsesMutation(input: $input) {
      response {
        ${baseResponse}
      }
      data {
       ${formFixedResponseFields}
      }
    }
  }`


export const GET_FORM_FIXED_RESPONSE = gql`
  query GetFormFixedResponsesFields($filtering: FormFixedFieldsFilteringInput) {
    getFormFixedResponsesFields(filtering: $filtering) {
      response {
        ${baseResponse}
      }
      data {
        ${formFixedResponseFields}
      }
    }
  }`

export const UPDATE_FORM_FIXED_RESPONSE = gql`
  mutation UpdateFormFixedResponsesMutation($input: FormFixedResponseFieldsInputObjects!) {
    updateFormFixedResponsesMutation(input: $input) {
      response {
        ${baseResponse}
      }
      data {
        ${formFixedResponseFields}
      }
    }
  }`

export const DELETE_FORM_FIXED_RESPONSE = gql`
  mutation DeleteFormFixedResponsesMutation($uniqueId: String!) {
    deleteFormFixedResponsesMutation(uniqueId: $uniqueId) {
      response {
        ${baseResponse}
      }
    }
  }`
